import React, { Component } from 'react'

import withCssClassName from '../with-css-class-name'

class CaretLeftIcon extends Component {
    render() {
        return (
            <svg {...this.props} xmlns="http://www.w3.org/2000/svg" width="6" height="10" viewBox="0 0 6 10"><path d="M6 1.054L4.955 0 0 5l4.955 5L6 8.946 2.09 5z"/></svg>
        )
    }
}

export default withCssClassName(CaretLeftIcon)



// WEBPACK FOOTER //
// src/components/svg-icon/icons/caret-left-icon.js